import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Facebook ad account currency is ILS - no conversion needed
export type DisplayCurrency = 'ILS';

/**
 * Format a currency value in ILS
 * Facebook data is already in ILS (ad account currency)
 */
export function formatCurrency(value: number): string {
  const formatter = new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: 'ILS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return formatter.format(value);
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('en-US').format(value);
}

export function formatPercent(value: number): string {
  return `${value.toFixed(2)}%`;
}

export function formatRatio(value: number): string {
  return value.toFixed(2);
}
